"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const contact_service_1 = require("./contact.service");
const create_contact_dto_1 = require("./dto/create-contact.dto");
const update_contact_dto_1 = require("./dto/update-contact.dto");
const contact_swagger_1 = require("./contact.swagger");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const enum_1 = require("../../../../../../libs/service-lib/src/lib/enum");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const get_all_contact_dto_1 = require("./dto/get-all-contact.dto");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
/**
 * Controller for handling contact-related requests.
 */
let ContactController = class ContactController {
    constructor(contactService, scopeService) {
        this.contactService = contactService;
        this.scopeService = scopeService;
    }
    /** Create a new contact. */
    async addContact(contact, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const contactData = await this.contactService.addContact(contact, userId);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.contactCreated, contactData));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(enum_1.statusCode.notFound)
                    .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.notFound, error.message || messages_1.errorMessages.contactNotFound));
            }
            else if (error instanceof common_1.ForbiddenException) {
                return res
                    .status(enum_1.statusCode.forbidden)
                    .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.forbidden, error.message || messages_1.errorMessages.contactCreationForbidden));
            }
            else {
                return res
                    .status(enum_1.statusCode.badRequest)
                    .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.unknownError));
            }
        }
    }
    /** Retrieve paginated contacts.*/
    async getContactList(getAllContacts, res, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const { page, limit, contactRecordTypeLid, sort, search, searchBy } = getAllContacts;
            const contactListData = await this.contactService.getContactList(Number(page), Number(limit), userId, Number(contactRecordTypeLid), search, sort, searchBy);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.contactListRetrieved, contactListData));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(enum_1.statusCode.notFound)
                    .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.notFound, error.message || messages_1.errorMessages.contactFetchFailed));
            }
            else {
                return res
                    .status(enum_1.statusCode.badRequest)
                    .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.unknownError));
            }
        }
    }
    /** Retrieve a single contact by ID.*/
    async getContactById(res, contactId, req) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, "Contact", "view", contactId);
            if (!viewValidation) {
                return res
                    .status(enum_1.statusCode.forbidden)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to view this company."));
            }
            const editValidation = await this.scopeService.validateResourceScope(userId, "Contact", "edit", contactId);
            const contactData = await this.contactService.getContactById(contactId);
            const response = { ...contactData, editable: editValidation };
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.contactDetails, response));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.notFound)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.notFound, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
    /** Update a contact by ID. */
    async updateContactById(res, req, contactId, updateContact) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const editValidation = await this.scopeService.validateResourceScope(userId, "contact", "edit", contactId);
            if (!editValidation) {
                return res
                    .status(enum_1.statusCode.forbidden)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company."));
            }
            const contactData = await this.contactService.updateContactById(contactId, updateContact, userId);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.contactUpdated, contactData));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(enum_1.statusCode.notFound)
                    .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.notFound, error.message || messages_1.errorMessages.contactNotFound));
            }
            else if (error instanceof common_1.ForbiddenException) {
                return res
                    .status(enum_1.statusCode.forbidden)
                    .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.forbidden, error.message || messages_1.errorMessages.contactUpdateForbidden));
            }
            else {
                return res
                    .status(enum_1.statusCode.badRequest)
                    .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, error instanceof Error
                    ? error.message
                    : messages_1.errorMessages.unknownError));
            }
        }
    }
    /** Remove a contact by ID. */
    async deleteContactById(req, res, contactId) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const editValidation = await this.scopeService.validateResourceScope(userId, "contact", "edit", contactId);
            if (!editValidation) {
                return res
                    .status(enum_1.statusCode.forbidden)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company."));
            }
            const contactData = await this.contactService.deleteContactById(contactId);
            if (contactData) {
                return res
                    .status(enum_1.statusCode.ok)
                    .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.contactDeleted));
            }
            else {
                return res
                    .status(enum_1.statusCode.notFound)
                    .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.notFound, messages_1.errorMessages.contactDeletionFailed));
            }
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.badRequest)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, error instanceof Error ? error.message : messages_1.errorMessages.unknownError));
        }
    }
};
exports.ContactController = ContactController;
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, contact_swagger_1.createContactSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Body)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof create_contact_dto_1.CreateContactDto !== "undefined" && create_contact_dto_1.CreateContactDto) === "function" ? _c : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], ContactController.prototype, "addContact", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, contact_swagger_1.getContactsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_d = typeof get_all_contact_dto_1.GetAllContactsDto !== "undefined" && get_all_contact_dto_1.GetAllContactsDto) === "function" ? _d : Object, Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], ContactController.prototype, "getContactList", null);
tslib_1.__decorate([
    (0, common_1.Get)(":id"),
    (0, contact_swagger_1.getContactSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Param)("id")),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], ContactController.prototype, "getContactById", null);
tslib_1.__decorate([
    (0, common_1.Put)(":id"),
    (0, contact_swagger_1.updateContactSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Res)()),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Param)("id")),
    tslib_1.__param(3, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Number, typeof (_e = typeof update_contact_dto_1.UpdateContactDto !== "undefined" && update_contact_dto_1.UpdateContactDto) === "function" ? _e : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], ContactController.prototype, "updateContactById", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":id"),
    (0, contact_swagger_1.deleteContactSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Req)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Param)("id")),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], ContactController.prototype, "deleteContactById", null);
exports.ContactController = ContactController = tslib_1.__decorate([
    (0, common_1.Controller)("contact"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contact_service_1.ContactService !== "undefined" && contact_service_1.ContactService) === "function" ? _a : Object, typeof (_b = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _b : Object])
], ContactController);
